// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8974) return "8974.48de078ce89e399c1720.app-chunk.min.js?v=1758074881474";
	// return url for filenames based on template
	return undefined;
};